import { render } from "./MakePage.vue?vue&type=template&id=ceafc2ba"
import script from "./MakePage.vue?vue&type=script&lang=js"
export * from "./MakePage.vue?vue&type=script&lang=js"
script.render = render

export default script